import React, {useEffect} from "react";
import { Page, Document, StyleSheet, Image,Font } from "@react-pdf/renderer";
import {PAYCELL_LOGO} from '../../constants'
import ReceiptHeader from "./ReceiptHeader";
import ReceiptTitle from "./ReceiptTitle";
import ReceiptBody from "./ReceiptBody";
import ReceiptFooter from "./ReceiptFooter";
import FontArial from '../../helpers/arial.ttf';

function Receipt({ receiptInfo }) {

    Font.register({
        family: 'Arial',
        fonts: [
            { src: FontArial}, // font-style: normal, font-weight: normal
            { src: FontArial, fontStyle: 'italic' },
            { src: FontArial, fontStyle: 'bold' },
            { src: FontArial, fontWeight: '400' },
        ] });

const styles = StyleSheet.create({
    page: {
        backgroundColor: '#fff',
        fontFamily: 'Arial',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft: 50,
        paddingRight: 50,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    logo: {
        width: '240px',
        height: '60px',
        marginLeft: 'auto',
        marginRight: 'auto',
        fill:'black'

    }
});

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap >
                <Image style={styles.logo} src={PAYCELL_LOGO} />
                <ReceiptHeader title={'İŞLEM FİŞİ'} />
                {/*<ReceiptTitle receipt={receiptInfo} />*/}
                <ReceiptBody receipt={receiptInfo} />
                <ReceiptFooter/>
            </Page>
        </Document>
    );
}

export default Receipt;